// extracted by mini-css-extract-plugin
export default {"header":"R6ZJcZ","subtitle":"N9XWzp","comment":"CxWNIm","button-wrapper":"O9QpLa","buttonWrapper":"O9QpLa","input-wrapper":"PkivfL","inputWrapper":"PkivfL"};